import { Event } from 'react-big-calendar';

export const WALKTHROUGH_EVENT_TYPE: number = 1;
export const SERVICE_REQUEST_EVENT_TYPE: number = 2;
export const KEY_PICKUP_EVENT_TYPE: number = 3;

// How the event was scheduled. The calendar API tags every event with this: legacy Juniper
// scheduling tables vs the Cal.com ScheduleEvents flow. Drives the "Cal.com" pill.
export type CalendarEventFlow = 'Legacy' | 'Calcom';

export interface IProperty {
  propertyId: string;
  name: string;
}

export interface ICalendarMetadataData {
  availableEventTypes: number[];
  availableProperties: IProperty[];
}

export interface ICalendarMetadataResponse {
  message: string;
  data: ICalendarMetadataData;
}

export interface ICalendarMetadataApiResult {
  ok: boolean;
  data?: ICalendarMetadataResponse;
  error?: string;
  status?: number;
}

export interface ICalendarEventData {
  appointmentId: string;
  suiteId: string;
  eventDateTime: string;
  name: string;
  juniperEventType:
    | typeof WALKTHROUGH_EVENT_TYPE
    | typeof SERVICE_REQUEST_EVENT_TYPE
    | typeof KEY_PICKUP_EVENT_TYPE;
  // Optional until the JSON key casing is verified at runtime — absent flow just means "no pill".
  flow?: CalendarEventFlow;
  // Present on Cal.com-booked events; drives the "View in Cal.com" deep-link. Null for legacy.
  calcomBookingUid?: string | null;
  createdAt: string;
  propertyId: string;
  propertyName: string;
  serviceRequestId: string | null;
  walkthroughId: string | null;
  daysSinceSubmitted: number | null;
  number: string;
  ticketNumber: string | null;
  homeOwner: string;
  status: string;
  description: string;
  eventHostUserId: string;
  // The Cal.com account owner who hosts this booking (resolved from EventOwnerJuniperUserId).
  // Optional until the calendar payload exposes them — used to name the owner on a non-host view.
  eventHostName?: string | null;
  eventHostEmail?: string | null;
  serviceProviderCompanyName: string | null;
  serviceProviderName: string | null;
  serviceProviderEmail: string | null;
  serviceProviderPhone: string | null;
  serviceProviderId: string | null;
}

export interface ICalendarEventsApiResponse {
  message: string;
  data: ICalendarEventData[];
}

export interface ICalendarEventsServiceResponse {
  ok: boolean;
  data?: ICalendarEventsApiResponse;
  error?: string;
  status?: number;
}

export interface IKeyPickupEventApiResponse {
  message: string;
  data: ICalendarEventData;
}

export interface IKeyPickupEventServiceResponse {
  ok: boolean;
  data?: IKeyPickupEventApiResponse;
  error?: string;
  status?: number;
}

export interface ICalendarEvent extends Event {
  id: number | string;
  title: string;
  start: Date;
  end: Date;
  allDay?: boolean;
  eventType: string;
  isCalcom: boolean;
  originalEvent: ICalendarEventData;
  [key: string]: any;
}

export interface IPropertyWithState {
  id: string;
  text: string;
  enabled: boolean;
}

export interface IUniqueEventType {
  text: string;
  value: string;
  color: string;
  textColor: string;
  enabled: boolean;
}
